// extracted by mini-css-extract-plugin
export var csatScore = "_n5-5";
export var header = "_n5-1";
export var panelWrapper = "_n5-2";
export var postPreview = "_n5-3";
export var rightContent = "_n5-0";
export var wrappingText = "_n5-4";